import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IconosService {
  public alertaPrincipal = [];
  public alertaSecundaria = [];
  public alertaGeocerca = [];
  public alertaEnergia = [];
  public alertaBateria = [];

  constructor() { }

  public colorPointPosition(estado) {
      let url = '';

    switch (estado) {
        case 0:
            url = './assets/media/marcadores/flechaGris.png';
            break;
        case 1:
            url = './assets/media/marcadores/flechaVerde.png';
            break
        case 2:
            url = './assets/media/marcadores/flechaRoja.png';
            break
        case 3:
            url = './assets/media/marcadores/flechaAmarilla.png';
            break
        case 4:
            url = './assets/media/marcadores/flechaAmarilla.png';
            break
        case 5:
            url = './assets/media/marcadores/flechaNaranja.png';
            break
        case 6:
            url = './assets/media/marcadores/flechaRoja.png';
            break
        case 7:
            url = './assets/media/marcadores/flechaAzul.png';
            break
        case 8:
            url = './assets/media/marcadores/flechaMorada.png';
            break
        case 9:
            url = './assets/media/marcadores/flechaRosa.png';
            break
        case 10:
            url = './assets/media/marcadores/flechaCafe.png';
            break
        case 11:
            url = './assets/media/marcadores/flechaGris.png';
            break

        default:
            url = './assets/media/marcadores/flechaGris.png';
            break;
    }
    return url;
  }

  public colorVehiculos(marker) {
    let urlMarker = '';
    switch (marker.estado) {
        case 0: {
            //gris
            urlMarker = './assets/media/autos/auto_gris.png';
            break;
        }
        case 1: {
            //Verde
            urlMarker = './assets/media/autos/auto_verde.png';
            break;
        }
        case 2: {
            //Rojo parpadeando
            this.alertaPrincipal.push(marker);
            urlMarker = './assets/media/autos/auto_rojo.png';
            break;
        }
        case 3: {
            //Amarillo parpadeando
            this.alertaSecundaria.push(marker);
            urlMarker = './assets/media/autos/auto_amarillo.png';
            break;
        }
        case 4: {
            //Amarillo
            urlMarker = './assets/media/autos/auto_amarillo.png';
            break;
        }
        case 5: {
            //Naranja
            urlMarker = './assets/media/autos/auto_naranja.png';
            break;
        }
        case 6: {
            //Rojo
            urlMarker = './assets/media/autos/auto_rojo.png';
            break;
        }
        case 7: {
            //Azul
            urlMarker = './assets/media/autos/auto_azul.png';
            break;
        }
        case 8: {
            this.alertaGeocerca.push(marker)
            urlMarker = './assets/media/autos/auto_morado.png';
			//urlMarker = './assets/media/autos/8L.gif';
            break;
        }
        case 9: {
            //
            this.alertaBateria.push(marker);
            urlMarker = './assets/media/autos/auto_rosa.png';
            break;
        }
        case 10: {
            //
            this.alertaEnergia.push(marker);
            urlMarker = './assets/media/autos/auto_cafe.png';
            break;
        }
        case 11: {
            //
            urlMarker = './assets/media/autos/auto_gris.png';
            break;
        }
        default: {
            urlMarker = 'http://www.star911.com.mx/Plataforma/Content/imagenes/iconos/0.gif';
            break;
        }
    }
    return urlMarker;
  }

  public colorApuntador(estado) {
    let url = '';
    switch (estado.estado) {
		case 0:
			//Detenido
			url = './assets/media/puntos/spinnerGris.png';
			break;
		case 1:
			//En movimiento
			url = './assets/media/puntos/spinner.png';
			break;
		case 2:
			//Alerta primaria (parpadeando)
			url = './assets/media/puntos/spinnerAlerta.png';
			break;
		case 3:
			url = './assets/media/puntos/spinnerAmarillo.png';
			break;
		case 4:
			//Detenido mas de 30 min
			url = './assets/media/puntos/spinnerAmarillo.png';
			break;
		case 5:
			//Detenido mas de 60 min
			url = './assets/media/puntos/spinnerNaranja.png';
			break;
		case 6:
			//Detenido mas de 90 min
			url = './assets/media/puntos/spinnerRojo.png';
			break;
		case 7:
			//Exceso de velocidad
			url = './assets/media/puntos/spinnerAzul.png';
			break;
		case 8:
			//Fuera geocerca
			url = './assets/media/puntos/spinnerMorado.png';
			break;
		case 9:
			//Bateria baja
			url = './assets/media/puntos/spinnerCafe.png';
			break;
		case 10:
			//Falta de energia
			url = './assets/media/puntos/spinnerRosa.png';
			break;
		case 11:
			//Alerta movimiento
			url = './assets/media/puntos/spinnerGris.png';
			break;
		default:
			url = './assets/media/puntos/spinnerRojo.png';
			break;
    }
    return url;
  }
}
